module.exports = __webpack_public_path__ + "static/finb1-5face02f9ddd599291e369093de6716e.jpg";